import Utils from '../../../../../viscomjs/utils/utils';
const THREE = require('three');

const prepareRenderer = (w, h) => {
    const renderer = new THREE.WebGLRenderer({alpha: false});
    renderer.setSize(w, h);
    renderer.setClearColor(0xffffff, 1);

    return renderer;
};

const prepareScene = () => {
    return new THREE.Scene();
};

const prepareCamera = params => {
    /*
     fov — Camera frustum vertical field of view.
     aspect — Camera frustum aspect ratio.
     near — Camera frustum near plane.
     far — Camera frustum far plane.
    * */

    const defaults = {
        fov: 15,
        aspect: 1,
        near: 1,
        far: 4000
    };

    const _params = Utils.extend(defaults, params);
    const camera = new THREE.PerspectiveCamera(_params.fov, _params.aspect, _params.near, _params.far);
    const cameraRigRoot = new THREE.Group();
    const cameraRigPOI = new THREE.Group();
    const cameraRigCurve = new THREE.Group();
    const cameraRigNull = new THREE.Group();
    cameraRigRoot.name = 'cameraRigRoot';
    cameraRigNull.name = 'cameraRigNull';
    // Point of interest to animate in front of camera:
    cameraRigPOI.name = 'cameraRigPOI';

    cameraRigCurve.add(cameraRigNull);
    cameraRigRoot.add(cameraRigCurve);

    return {camera, cameraRigRoot, cameraRigCurve, cameraRigNull, cameraRigPOI};
};

export {prepareRenderer, prepareCamera, prepareScene};
